import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import { MdOutlineFileUpload } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import closeIcon from "../../../images/close_icon.png";
import fileIcon from "../../../images/file_icon.png";
import { applyForTender } from '../../../Redux/Action/Dashboard';
import Loader from '../../../Utils/Loader';
import { errorNotify } from '../../../Utils/Toast';
import './AppliedTenders.css';

const SubmitStatusModal = ({ show, setShow, saveStatus, setSaveStatus, applyLoading, tender_id }) => {
    const dispatch = useDispatch();

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [comment, setComment] = useState('');

    const { loading: getAttachmentLoading, getAttachmentData } = useSelector((state) => state.getAttachments);

    useEffect(() => {
        if (getAttachmentData?.statusCode === 200) {
            setUploadedFiles([]);
        }
    }, [getAttachmentData])
    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const newFiles = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: (file.size / (1024 * 1024)).toFixed(2),
            format: file.type.split('/')[1].toUpperCase(),
            file: file
        }));

        setUploadedFiles([...uploadedFiles, ...newFiles]);
    };

    const removeFile = (fileId) => {
        setUploadedFiles(uploadedFiles.filter(file => file.id !== fileId));
    };

    const cancelHandler = () => {
        setShow(false);
        setUploadedFiles([]);
        setComment('');
        setSaveStatus(null)
    }

    const submitHandler = () => {
        if (uploadedFiles.length === 0 && comment === '') {
            errorNotify("Please filled up atleast one field")
            return
        }

        const formData = new FormData();
        formData.append('tender_id', tender_id);
        formData.append('comments', comment);
        uploadedFiles.forEach(file => {
            formData.append('media', file.file);
        });
        formData.append('status', saveStatus === 'won' ? 'win' : 'lose');

        dispatch(applyForTender(formData))

    }

    return (
        <Modal centered className='doc_type' size='lg' show={show} onHide={setShow}>
            <Modal.Body>
                <div className='add_doc_type'>
                    <div className='head'>
                        <h5>Tender Details</h5>
                    </div>
                    {
                        getAttachmentLoading ? <Loader /> :
                            <div className='document_upload_box'>

                                <div className='reason_status'>
                                    <label>Reason for {saveStatus === 'won' ? 'Winning' : 'Losing'}</label>
                                    <textarea rows={4} placeholder='Competitive pricing, strong proposal, past experience...'
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    />
                                </div>

                                <div className='upload_box'>
                                    <MdOutlineFileUpload />
                                    <div>
                                        <p>Upload or Drag and Drop your document</p>
                                        <span>Maximum File Size is 20MB</span>
                                        <span>Supported File Types are: .png, .jpg, .pdf, .csv</span>
                                        <input
                                            type="file"
                                            onChange={handleFileUpload}
                                            accept=".png,.jpg,.pdf,.csv"
                                            multiple
                                        />
                                    </div>
                                </div>

                                {uploadedFiles.length > 0 && (
                                    <div className='atatchment_box'>
                                        <h5>Preview</h5>
                                        <Row>
                                            {uploadedFiles.map((file) => (
                                                <Col md={6} key={file.id}>
                                                    <div className='attachment_item'>
                                                        <img
                                                            src={closeIcon}
                                                            alt=''
                                                            className='close_icon'
                                                            onClick={() => removeFile(file.id)}
                                                        />
                                                        <img src={fileIcon} alt='' />
                                                        <div>
                                                            <h6>{file.name}</h6>
                                                            <span>File Format: {file.format}</span>
                                                            <span>File Size: {file.size}MB</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>
                                )}

                                {
                                    getAttachmentData?.data?.documents?.length > 0 && (
                                        <div className='atatchment_box'>
                                            <h5>Attachments</h5>
                                            <Row>
                                                {getAttachmentData?.data?.documents.map((file) => {
                                                    const fileURL = file?.media?.split('/')
                                                    const fileformat = fileURL[fileURL.length - 1].split('.')

                                                    return (
                                                        <Col md={6} key={file.id}>
                                                            <>
                                                                <p>{file?.user?.user_name}</p>
                                                                <div className='attachment_item'>
                                                                    <img src={fileIcon} alt='' />
                                                                    <div>
                                                                        <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                        <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </div>
                                    )
                                }

                                <div className='status_submit_actions'>
                                    <button onClick={cancelHandler}>Cancel</button>
                                    <button onClick={submitHandler}>{applyLoading ? <Spinner animation={'border'} size='sm' /> : 'Submit'}</button>
                                </div>
                            </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SubmitStatusModal;